/* eslint-disable no-console */
(() => {
  /* ---------- Helper: dinheiro ------------------------------------ */
  const moneyFmt = window.moneyFormat || 'R$ {{amount}}';
  const formatCash = raw => {
    const cents = typeof raw === 'number'
      ? raw
      : Math.round(parseFloat(raw) * 100);

    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, moneyFmt);
    }
    return moneyFmt.replace(
      /{{\s*[\w_]+\s*}}/,
      (cents / 100).toFixed(2).replace('.', ',')
    );
  };

  /* ---------- ViaCEP ---------------------------------------------- */
  const UF_MAP = {
    AC: 'Acre', AL: 'Alagoas', AP: 'Amapa', AM: 'Amazonas', BA: 'Bahia',
    CE: 'Ceara', DF: 'Distrito Federal', ES: 'Espirito Santo', GO: 'Goias',
    MA: 'Maranhao', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais', PA: 'Para', PB: 'Paraiba', PR: 'Parana',
    PE: 'Pernambuco', PI: 'Piaui', RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondonia',
    RR: 'Roraima', SC: 'Santa Catarina', SP: 'Sao Paulo', SE: 'Sergipe',
    TO: 'Tocantins'
  };

  async function getProvinceFromCEP(cep) {
    try {
      const data = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
        .then(r => r.json());
      if (data.erro) return null;
      return { code: data.uf, name: UF_MAP[data.uf] || null };
    } catch (e) {
      console.warn('ViaCEP falhou:', e.message);
      return null;
    }
  }

  /* ---------- Cálculo --------------------------------------------- */
  const ROOT = window.Shopify?.routes?.root || '/';

  async function calculate(root) {
    if (root.dataset.busy === '1') return;     // evita duplo clique
    root.dataset.busy = '1';

    const zipInput = root.querySelector('[data-zip]');
    const output   = root.querySelector('[data-shipping-result]');
    const cep = (zipInput?.value || '').replace(/\D/g, '');

    if (cep.length !== 8) {
      output.textContent = 'CEP inválido';
      root.dataset.busy = '';
      return;
    }
    output.textContent = 'Calculando…';

    /* 1. UF */
    const provinceObj = await getProvinceFromCEP(cep);
    if (!provinceObj) {
      output.textContent =
        'Não foi possível identificar o estado. Tente novamente.';
      root.dataset.busy = '';
      return;
    }

    /* 2. Payload */
    const addr = {
      zip          : cep,
      country      : 'Brazil',
      country_code : 'BR',
      province     : provinceObj.name,
      province_code: provinceObj.code
    };

    /* 3. prepare_shipping_rates */
    const prepRes = await fetch(`${ROOT}cart/prepare_shipping_rates.json`, {
      method : 'POST',
      headers: {
        'Content-Type'    : 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ shipping_address: addr })
    });

    if (!prepRes.ok) {
      const err = await prepRes.json().catch(() => ({}));
      output.textContent =
        err.error || err.message || `Erro ${prepRes.status}`;
      root.dataset.busy = '';
      return;
    }

    /* 4. async_shipping_rates */
    const qs = new URLSearchParams({
      'shipping_address[zip]'     : cep,
      'shipping_address[country]' : 'Brazil',
      'shipping_address[province]': provinceObj.name
    }).toString();

    let rates;
    for (let i = 0; i < 20; i++) {
      await new Promise(r => setTimeout(r, 500));
      rates = await fetch(
        `${ROOT}cart/async_shipping_rates.json?${qs}`,
        { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
      ).then(r => r.json()).catch(() => null);
      if (rates?.shipping_rates) break;
    }

    if (!rates?.shipping_rates?.length) {
      output.textContent =
        'Não foi possível calcular o frete. Tente novamente.';
      root.dataset.busy = '';
      return;
    }

    /* 5. Renderização */
    output.innerHTML = rates.shipping_rates.map(rate => {
      const days = Array.isArray(rate.delivery_days) && rate.delivery_days.length
        ? Math.max(...rate.delivery_days)
        : null;
      const eta =
        rate.description ||
        (days ? `Até ${days} dias úteis` : 'Prazo indisponível');
      return `
        <div class="shipping-item">
          <span><strong>${rate.name}</strong> — ${eta}</span>
          <strong>${formatCash(rate.price)}</strong>
        </div>`;
    }).join('');

    root.dataset.busy = '';
  }

  /* ---------- Delegação: submit + click --------------------------- */
  function findRoot(el) {
    return el?.closest('[data-shipping-root]');
  }

  /* 1. Enter ou clique dentro do <form> */
  document.addEventListener('submit', ev => {
    const form = ev.target.closest('[data-shipping-form]');
    if (!form) return;
    ev.preventDefault();
    const root = findRoot(form);
    if (root) calculate(root);
  });

  /* 2. Clique em qualquer botão com o atributo */
  document.addEventListener('click', ev => {
    const btn = ev.target.closest('[data-calc-shipping]');
    if (!btn) return;
    ev.preventDefault();
    const root = findRoot(btn);
    if (root) calculate(root);
  });
})();
